<template>
    <div>
        <div style="margin-bottom: 20px;">
            <el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
        </div>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <el-table
                :data="transferList.list"
                size="mini"
                border
                style="width: 100%"
                v-loading="loading"
            >
                <!-- 划拨订单号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="name"
                    label="划拨人"
                    min-width="250"
                ></el-table-column>
                <!-- 货款订单号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="brand_name"
                    label="品牌"
                    min-width="120"
                ></el-table-column>
                <!-- 发起人账号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="phone"
                    label="手机号"
                    min-width="120"
                ></el-table-column>
                <!-- 被划拨人姓名 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="terminal_num"
                    label="划拨数量"
                    min-width="120"
                ></el-table-column>
                <!-- 被划拨人账号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="transfer_time"
                    label="划拨时间"
                    min-width="120"
                ></el-table-column>
                <!-- 被划拨人账号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="statusname"
                    label="上级划拨状态"
                    min-width="120"
                ></el-table-column>

                <!-- 操作 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed="right"
                    label="操作"
                    min-width="150"
                >
                <template slot-scope="scope" >
                    <el-button
                        v-show="scope.row.status == 1"
                        @click="handleRevocation(scope.row)"
                        type="text"
                        size="small"
                    >确认接收</el-button>
                </template>
                </el-table-column>
            </el-table>
        </el-card>
        <!-- 终端数量 -->
        <terminal-count
            v-if="infoIsShow"
            :infoIsShow="infoIsShow"
            :listId="listId"
            @infoClose="infoClose"
        ></terminal-count>
    </div>
</template>

<script>
import paginations from '../../../components/pagination/paginations';
import terminalCount from './MAM_terminalCount';
export default {
    name: "MAM_transferTerminalInfo",
    data() {
        return {
            level:sessionStorage.getItem('level'),
            repayment_type: '',
            number:0,
            infoIsShow: false, //弹窗
            listId: null,
            brandList: [],
            reason: '', //拒绝原因
            formInline: {
                order_num: '', //订单号
                transfer_user_name: '', //发起人姓名
                receive_user_name: '', //被划拨人姓名
                brand_id: '', //终端类型id
                pay_type: '', //支付方式
                status: '', //划拨状态
                rangeDate: '', //订单创建时间
                terminal_sn: ''
            },
            transferList: {
                list: [],
            },
            page: {
                currentPage: 1, //当前页码
                pageSize: 10, //条数
                total: 0  //总数
            },
            condition: {},//
            loading: true
        }
    },
    mounted() {
        this.repayment_type = sessionStorage.getItem('repayment_type');
        this.getData({
            page: this.page.currentPage,
            limit: this.page.pageSize,
        })
    },
    components: {
        paginations,
        terminalCount
    },
    methods: {
        onSearch(formInline) { //搜索
            this.page.currentPage = 1;
            let rangeDate = formInline.rangeDate;
            formInline.start_time = rangeDate ? rangeDate[0] : '';
            formInline.end_time = rangeDate ? rangeDate[1] : '';
            this.condition = formInline;
            // 表单提交
            this.getData({
                condition: JSON.stringify(formInline),
                page: 1,
                limit: this.page.pageSize,
            })
        },
        //
        handleDetail(row) { //终端数量
            this.infoIsShow = true;
            this.listId = row.id;
        },
        handleRevocation(row) { //撤销
            let that = this;
            this.$confirm('是否确认接收终端？', '提 示', {
                type: 'warning',
                distinguishCancelAndClose: true,
                confirmButtonText: '确 定',
                cancelButtonText: '取 消'
            }).then(() => {
                this.$api.post('terminal_transfer/terminal_transfer_deal', { id: row.id,type:2 }, res => {
                    if (res.code == 0) {
                        this.$message({
                            type: 'success',
                            message: res.msg,
                            duration: 2000,
                            onClose() {
                                that.getData({
                                    condition: JSON.stringify(that.formInline),
                                    page: that.page.currentPage,
                                    limit: that.page.pageSize
                                })
                            }
                        })
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            }).catch(() => {

            })
        },
        handleRefusalCause(row) { //查看拒绝原因
            this.reason = row.reason;
        },
        transferTerminal() { //终端划拨
            this.$router.push({ path: '/transferTerminal' })
        },
        transferTerminalInfo() { //终端划拨
            this.$router.push({ path: '/transferTerminalInfo' })
        },
        infoClose() {
            this.infoIsShow = false;
        },
        //分页
        getCurrent(page) {
            // 获取当前页修改的值
            this.page.currentPage = page;
            this.loading = true;
            this.getData({
                condition: JSON.stringify(this.formInline),
                page: this.page.currentPage,
                limit: this.page.pageSize,
            });
        },
        getPageSize(limit) {
            this.page.currentPage = 1;
            // 获取条数发生改变的值
            this.page.pageSize = limit;
            this.loading = true;
            this.getData({
                condition: JSON.stringify(this.formInline),
                page: this.page.currentPage,
                limit: limit,
            })
        },
        getData(params) {
            this.$api.post("terminal_transfer/terminal_transfer_receive_log", params, res => {
                let data = res.data;
                this.page.total = data.count; //总数
                this.transferList.list = res.data;
                //渲染结束后取消加载
                this.loading = false;
            })
        }
    }
};
</script>

<style lang="scss" scope>
.el-input__inner {
    font-size: 12px;
}
.el-form-item {
    margin-bottom: 5px;
}
.el-date-editor .el-range-input,
.el-date-editor .el-range-separator {
    font-size: 12px;
}
.el-popover__title {
    font-size: 12px;
    font-weight: 700;
}
</style>
